import {
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Alert,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from '../../redux/hooks/useSelector'
import { ContactAdressInput } from '../ClientInformationDialog/ContactAdressInput'
import { ClientInformationDialogFooter } from '../ClientInformationDialog/ClientInformationDialogFooter'
import { closeDialog, openDialog } from '../../redux/actions/dialogActions'
import { CLIENT_EMAIL_DUPLICITY_DIALOG_ID, CLIENT_INFORMATION_DIALOG_ID } from '../../constants/dialogConstants'
import { ClientNameContainer } from '../ClientInformationDialog/ClientNameContainer'
import { ClientPersonalDataContainer } from '../ClientInformationDialog/ClientPersonalDataContainer'
import { Client, ClientPortfolioType, ClientRole, ClientPerson, requiredClientAttributes, requiredClientCompanyAttributes, Contract } from '../../redux/reducers/clients'
import { emptyClient, emptyClientPortfolioType } from '../../constants/initialStates'
import { useClientApi } from '../../hooks/useClientApi'
import { usePersonApi } from '../../hooks/usePersonApi'
import { changeFormValidity, setErrors } from '../../redux/actions/userActions'
import { ActionFailedAlert } from './ActionFailedAlert'
import { ActionAlert } from './ActionAlert'
import Autocomplete from '@mui/material/Autocomplete'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import AdapterDateFns from '@date-io/date-fns'
import DatePicker from '@mui/lab/DatePicker'
import SwipeableViews from 'react-swipeable-views'
import PersonOutlineIcon from '@mui/icons-material/PersonOutlineRounded'
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWalletRounded'
import { ColoredIconButton } from '../common/ColoredIconButton'
import AddIcon from '@mui/icons-material/AddRounded'
import RemoveIcon from '@mui/icons-material/RemoveRounded'
import { useRoleApi } from '../../hooks/useRoleApi'
import { TFunction, useTranslation } from 'react-i18next'
import { RootState } from '../../redux/reducers/root'
import { CLIENT_CATEGORY, CLIENT_EXPERIENCE, CLIENT_LOSS_ABILITY, CLIENT_PREFERENCE, CLIENT_SUITABILITY, CONTRACT_TYPE, PERSON_CONTACT_TYPE } from '../../constants/codeLists'
import { useInstrumentApi } from '../../hooks/useInstrumentApi'
import { codeListCodeItems, personsItems } from '../../utils/codeListToArrowSelect'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOfflineRounded'
import { useInvestmentApi } from '../../hooks/useInvestmentApi'
import { newThemeObject } from '../../newTheme'
import { CLEAR_VALID_CLIENT } from '../../redux/actionTypes'
import { isApexUser } from '../../utils/apex'
import { useContractApi } from '../../hooks/useContractApi'
import { tokens } from '../../styles/tokens'
import { useSegmentedTabsStyles } from '../../styles/segmentedTabs'
import { cardHeaderActionSx, useCardHeaderStyles } from '../../styles/cards'
import useMobileWidth from '../../hooks/useMobileWidth'



// TODO
const useStyles = makeStyles(theme => ({
  buttonRemove: {
    height: '20px',
    width: '20px',
    marginTop: '5px'
  },
  clientInformationDialogHeader: {
    width: '100%',
    height: 60,
    display: 'flex',
    alignItems: 'center',
    background: `linear-gradient(135deg, ${tokens.color.primary[800]}, ${tokens.color.primary[600]})`,
    borderRadius: '16px 16px 0 0',
    color: theme.palette.primary.contrastText,
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(0.75),
    paddingRight: theme.spacing(2),
    justifyContent: 'space-around',
  },
  separator: {
    flexGrow: 1,
  },
  clientInformationDialog: {
    display: 'flex',
    flexDirection: 'row',
  },
  dialogActions: {
    justifyContent: 'center',
  },
  marginTopOverride: {
    marginTop: '0px',
  },
  errorBorder: {
    border: `1px solid ${theme.palette.error.main}`,
  },
  chips: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
  },
  actionButtons: {
    width: '50%',
  },
  dialogPaper: {
    minHeight: '80vh',
    maxHeight: '80vh',
  },
  cardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
  cardMuted: {
    borderRadius: tokens.radius.lg,
    boxShadow: tokens.shadow.sm,
    padding: theme.spacing(2),
    backgroundColor: tokens.color.neutral[50],
  },
  portfolioList: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    borderRadius: tokens.radius.lg,
    boxShadow: tokens.shadow.sm,
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(2),
  },
  portfolioListReal: {
    backgroundColor: tokens.color.primary[50],
  },
  rowOrderState: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '1rem',
    height: '2rem',
    width: 'fit-content',
    textAlign: 'center',
    paddingLeft: "1rem",
    paddingRight: "1rem",
  },
  rowOrderStateText: {
    opacity: '0.5',
    fontWeight: '500',
    fontSize: '0.85rem',
    margin: 0,
  },
}))

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function a11yProps(index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  }
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      style={{ width: '100%', height: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

const getKCLabelForClient = (client: Client, t: TFunction<"translation", undefined>) => {
  if (!client.createdKcUser) {
    return t("KC_CREATE_USER");
  } else if (client.activeKcUser) {
    return t("KC_DISABLE_USER");
  } else { // !client.activeKcUser
    return t("KC_ENABLE_USER");
  }
}

const getKCStatusForClient = (client: Client, t: TFunction<"translation", undefined>) => {
  if (!client.createdKcUser) {
    return t("HAS_NOT_KC_ACTIVE_USER");
  } else if (client.activeKcUser) {
    return t("HAS_KC_ACTIVE_USER");
  } else { // !client.activeKcUser
    return t("HAS_KC_INACTIVE_USER");
  }
}

interface Props {
  portfolio: ClientPortfolioType
  errors: Record<string, boolean>
  index: number
  onPortfolioChange: (index: number, value: string | boolean, field: string) => void
  handleSave?: () => void
  handleRemove?: (index: number) => void
  showError?: boolean
}

export const PortfolioDetail: React.FC<Props> = ({
  portfolio,
  errors,
  index,
  onPortfolioChange,
  handleSave,
  handleRemove,
  showError
}) => {
  const { t } = useTranslation()
  const user = useSelector(state => state.auth.user)
  const isMobile = useMobileWidth()

  return (
    <Paper
      style={{
        padding: '5px',
        height: isMobile ? 'auto' : '80px',
        margin: '5px 0',
        borderRadius: tokens.radius.md,
        boxShadow: tokens.shadow.sm,
      }}
    >
      <Grid container spacing={2} style={{ height: isMobile ? 'auto' : '80px' }} justifyContent="center" alignItems="center">
        <Grid
          item
          xs={12}
          sm={5}
          style={{ height: isMobile ? 'auto' : '60px', display: 'flex', alignContent: 'center' }}
          alignItems="center"
          justifyContent="center"
        >
          <TextField
            fullWidth
            required={showError}
            variant="outlined"
            label={t('NAME')}
            helperText={errors['portfolio_name'] && showError && !portfolio?.name ? t('REQUIRE_ITEM') : ''}
            error={showError && !portfolio?.name ? errors['portfolio_name'] : undefined}
            value={portfolio?.name}
            onChange={event => {
              onPortfolioChange(index, event.target.value, 'name')
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={3}
          style={{ height: isMobile ? 'auto' : '60px', display: 'flex', alignContent: 'center' }}
          alignItems="center"
          justifyContent="center"
        >
          <TextField
            fullWidth
            required={showError}
            variant="outlined"
            label={isApexUser(user) ? t('APEX_EXTERNAL_ID') : t('EXTERNAL_ID')}
            helperText={errors['external_id'] && showError && !portfolio?.externalId ? t('REQUIRE_ITEM') : ''}
            error={showError && !portfolio?.externalId ? errors['external_id'] : undefined}
            value={portfolio?.externalId}
            onChange={event => {
              onPortfolioChange(index, event.target.value, 'externalId')
            }}
          />
        </Grid>
        <Grid
          item
          xs={8}
          sm={2}
          style={{ height: isMobile ? 'auto' : '60px', display: 'flex', alignContent: 'center' }}
          alignItems="center"
          justifyContent="center"
        >
          <TextField
            fullWidth
            variant="outlined"
            label={t('FIX_CLIENT_ID')}
            value={portfolio?.clientExternalId ?? ''}
            onChange={event => {
              onPortfolioChange(index, event.target.value, 'clientExternalId')
            }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          style={{ height: isMobile ? 'auto' : '60px', display: 'flex', alignContent: 'center' }}
          alignItems="center"
          justifyContent="center"
        >
          <TextField
            fullWidth
            required={showError}
            id="standard-select-currency"
            select
            label={t('CURRENCY')}
            helperText={errors['portfolio_currency'] && showError && !portfolio?.currency ? t('REQUIRE_ITEM') : ''}
            error={showError && !portfolio?.currency ? errors['portfolio_currency'] : undefined}
            value={portfolio?.currency}
            onChange={event => {
              onPortfolioChange(index, event.target.value, 'currency')
            }}
          >
            <MenuItem key="CZK" value="CZK">
              CZK
            </MenuItem>
            <MenuItem key="USD" value="USD">
              USD
            </MenuItem>
            <MenuItem key="EUR" value="EUR">
              EUR
            </MenuItem>
            <MenuItem key="GBP" value="GBP">
              GBP
            </MenuItem>
          </TextField>
        </Grid>
        <Grid
          item
          xs={4}
          sm={1}
          style={{ height: isMobile ? 'auto' : '60px', display: 'flex', alignContent: 'center' }}
          alignItems="center"
          justifyContent="center"
        >
          {handleSave && <ColoredIconButton icon={<AddIcon />} size="small" onClick={() => handleSave()} />}
          {!handleSave && handleRemove && (
            <ColoredIconButton
              icon={<RemoveIcon />}
              size="small"
              disabled={portfolio.portfolioId ? true : false}
              onClick={() => handleRemove(index)}
            />
          )}
        </Grid>
      </Grid>
    </Paper>
  )
}

interface PropsDialog {
    setOpenConfirmation: (param: boolean) => any
    openConfirmationSave: boolean
    setOpenConfirmationSave: (param: boolean) => any
}
const DEFAULT_CREW_APEX = ['CEO']
const DEFAULT_CREW_IMPERIUM = ['CEO', 'PORTF MANAGER', 'ASSISTANT', 'ADMIN']

export const ClientInformationDialog:React.FC<PropsDialog> = ({
  setOpenConfirmation,
  openConfirmationSave,
  setOpenConfirmationSave
}) => {
  const classes = useStyles()
  const cardHeader = useCardHeaderStyles()
  const segTabs = useSegmentedTabsStyles()
  const dialogs = useSelector(state => state.dialogs.dialogs)
  const user = useSelector(state => state.auth.user)
  const { postClient, updateClient, validClient, getClientRoles, getClientPersons } = useClientApi()
  const { getPersons } = usePersonApi();
  const foundDialog = dialogs.find(dialog => dialog.id === 'CLIENT_INFORMATION_DIALOG_ID')
  const open = !!foundDialog
  const [contactAdressCheckState, setContactAdressState] = React.useState(false)
  const [client, setClient] = useState<Client>(emptyClient)
  const [newPortfolio, setNewPortfolio] = useState<ClientPortfolioType>(emptyClientPortfolioType)
  const clientRoles = useSelector(state => state.clients.clientRoles)
  const persons = useSelector(state => state.persons.persons)
  const clientPersons = useSelector(state => state.clients.clientPersons)
  const valid = useSelector(state => state.useractions.valid)
  const dispatch = useDispatch()
  const errors = useSelector(state => state.useractions.errors)
  const [clientSent, setClientSent] = useState(false)
  const { codeList, getCodeList } = useInstrumentApi()
  const clientNameFromEmail = useSelector(state => state.clients.clientName);
  
  const roles: string[] = useSelector((state: RootState) => state.roles.roles)
  const contracts: Contract[] = useSelector((state: RootState) => state.contracts.contracts)

  const { getRoles } = useRoleApi()
  const { getContracts } = useContractApi()

  const { t } = useTranslation()

  useEffect(() => {
    getClientRoles()
    getCodeList()
    getPersons()
  }, [])

  useEffect(()=>{
    if (client) {
      setClient({...client, clientPersons: clientPersons})
    }
  }, [clientPersons])

  useEffect(() => {
    if (foundDialog?.payload.client) {
      setClient(foundDialog?.payload.client)
      getRoles(foundDialog?.payload.client.clientId)
      getClientPersons(foundDialog?.payload.client.clientId);
      getContracts(foundDialog?.payload.client.clientId);
    }
  }, [foundDialog])

  useEffect(() => {
    if (client.permanentAddress === null) {
      setClient({
        ...client,
        permanentAddress: {
          addressId: null,
          street: null,
          town: null,
          zipCode: null,
          country: null,
          addressType: 'PERMANENT',
        },
      })
    }
  }, [client.permanentAddress])

  useEffect(() => {
    setClient({ ...client, roles: roles, contracts: contracts })
  }, [roles, contracts])

  // Vychozi obsluha noveho klienta. Klienta vidi jen ten, jehoz role je u nej zapsana,
  // proto v Imperiu nestaci samotny CEO - PM, asistenti a admini by klienta nevideli.
  const isNewClient = foundDialog?.payload?.type === 'new'
  useEffect(() => {
    if (isNewClient && clientRoles.length > 0) {
      const defaults = isApexUser(user) ? DEFAULT_CREW_APEX : DEFAULT_CREW_IMPERIUM
      const defaultRoles = clientRoles.filter(r => defaults.includes(r.name)).map(r => r.name)
      setClient(current => ({ ...current, roles: defaultRoles }))
    }
  }, [isNewClient, clientRoles, user])

  useLayoutEffect(() => {
    return () => {
      dispatch(closeDialog(CLIENT_INFORMATION_DIALOG_ID))
      setContactAdressState(false)
      setClient(emptyClient)
      dispatch(setErrors({}))
      dispatch(changeFormValidity(true))
    }
  }, [])

  useEffect(()=>{
    if ( openConfirmationSave ) {
        handleSaveValid()
        dispatch({type:CLEAR_VALID_CLIENT, payload:{}})
        setOpenConfirmationSave(false)
    }
  },
  [openConfirmationSave])

  useEffect(()=>{
    console.log('clientNameFromEmail', clientNameFromEmail);
    if ( clientNameFromEmail && clientNameFromEmail.name ) {
      setOpenConfirmation(true)
    } else {
      if ( clientNameFromEmail && clientNameFromEmail.valid ) {
        handleSaveValid()
        dispatch({type:CLEAR_VALID_CLIENT, payload:{}})
      }
    }
  }, [clientNameFromEmail])

  const isValid = () => {
    let valid = true
    let errorKeys = []
    const errors: {
      [key: string]: boolean
    } = {}
    for (const [key, value] of Object.entries(client)) {
      if (!requiredClientAttributes.includes(key)) continue
      if (key === 'roles' && (!value || value.length === 0)) {
        valid = false
        errors[key] = true
        errorKeys.push(key)
        continue
      }
      if (!value || (value && !String(value).trim())) {
        valid = false
        errors[key] = true
        errorKeys.push(key)
      }
    }

    for (const [key, value] of Object.entries(client.permanentAddress)) {
      if (!requiredClientAttributes.includes(key)) continue

      if (!value || (value && !String(value).trim())) {
        valid = false
        errors[key] = true
        errorKeys.push(key)
      }
    }

    if ( client.company && client.companyAddress ) {
      for (const [key, value] of Object.entries(client.companyAddress)
        .concat(Object.entries({Name: client.companyName, Id: client.companyId})) ) {
      
        if (!requiredClientCompanyAttributes.includes(key)) continue

        if (!value || (value && !String(value).trim())) {
          valid = false
          errors['company'+key] = true
          errorKeys.push('company'+key)
        }
      }
    }

    if (client.shouldHaveKcUser && !client.email) {
      valid = false
      errors['email'] = true
      errorKeys.push('email')
    }

    if (errorKeys.length != 0) {
      document?.querySelector(`input[id=${errorKeys[0]}]`)?.scrollIntoView({ behavior: 'smooth' })
    }

    for (let i=0; i<client.portfolios.length; i++) {
      // PT_ALL is a virtual aggregate computed by the backend, not an editable portfolio
      if ( client.portfolios[i].type === 'PT_ALL' ) continue
      if ( !client.portfolios[i].name ) {
        valid = false
        errors['portfolio_name'] = true
        errorKeys.push('portfolio_name')
      }
      if ( !client.portfolios[i].currency ) {
        valid = false
        errors['portfolio_currency'] = true
        errorKeys.push('portfolio_currency')
      }
      if ( !client.portfolios[i].externalId ) {
        valid = false
        errors['external_id'] = true
        errorKeys.push('external_id')
      }
    }



    dispatch(setErrors(errors))
    return valid
  }

  const contactAdressCheckStateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setContactAdressState(event.target.checked)
    setClient({
      ...client,
      contactAddress: {
        addressId: null,
        street: null,
        town: null,
        zipCode: null,
        country: null,
        addressType: 'CONTACT',
      },
    })
  }

  const handleClose = () => {
    dispatch(closeDialog(CLIENT_INFORMATION_DIALOG_ID))
    setContactAdressState(false)
    setClient(emptyClient)
    dispatch(setErrors({}))
    dispatch(changeFormValidity(true))
  }

  const onSubmitClick = () => {
    if (isValid()) {
      handleSave()
    }
  }

  const trimAllValues = (object: Record<string, any>) => {
    const objectCopy: Record<string, any> = { ...object }
    for (const [key, value] of Object.entries(object)) {
      if (typeof value === 'string') {
        objectCopy[key] = value.trim()
      }
      // if (!Array.isArray(value) && typeof value === 'object' && value !== null) {
      //   objectCopy[key] = trimAllValues(value)
      // }
    }
    return objectCopy
  }

  const handleSave = () => {
    if (clientSent) return
    let clientCopy = trimAllValues(client) as Client
    clientCopy.portfolios = clientCopy.portfolios.filter(portfolio => portfolio.type !== 'PT_ALL')
    if ( clientCopy && clientCopy.personalNumber ) {
      clientCopy.personalNumber = clientCopy.personalNumber.replaceAll('/', '')
    }
    if (foundDialog?.payload.type === 'new') {
      setClientSent(true)
      postClient(clientCopy).finally(() => {
        setClientSent(false)
      })
    } else if (foundDialog?.payload.type === 'edit') {
      validClient(clientCopy);
    }
  }

  const handleSaveValid = () => {
    let clientCopy = trimAllValues(client) as Client
    clientCopy.portfolios = clientCopy.portfolios.filter(portfolio => portfolio.type !== 'PT_ALL')
    if ( clientCopy && clientCopy.personalNumber ) {
      clientCopy.personalNumber = clientCopy.personalNumber.replaceAll('/', '')
    }
    console.log('ukladam klienta po odsouhlaseni', clientCopy);
    handleClose()
    updateClient(clientCopy).finally(() => {
      setClientSent(false)
    })
  }

  const onClientAttributeChange = (name: string) => (value: any) => {
    setClient({ ...client, [name]: value })
    if ((value instanceof String) && value.trim()) {
      dispatch(setErrors({ ...errors, [name]: undefined }))
    }
  }

  const onClientPermanentAddressChange = (name: string) => (value: any) => {
    setClient({ ...client, permanentAddress: { ...client.permanentAddress, [name]: value } })
    if (value.trim()) {
      dispatch(setErrors({ ...errors, [name]: undefined }))
    }
  }

  const onClientContactAddressChange = (name: string) => (value: any) => {
    setClient({ ...client, contactAddress: { ...client.contactAddress, [name]: value } })
  }

  const onClientInputChangeCreator = (name: string) => (event: any) => {
    onClientAttributeChange(name)(event.target.value)
  }

  const hadleChangeUid = (contract: Contract) => (event: any) => {
    if ( client && client.contracts ) {
      let tmpList : Contract[] = client.contracts ? [...client.contracts] : [];
      for ( let i=0; i<client.contracts?.length; i++) {
        if ( client.contracts[i].contractId === contract.contractId) {
          client.contracts[i].uid = event.target.value;
        }
      }
      setClient({...client, contracts: tmpList});
    }    
  }

  const onClientCompanyAddressChange = (name: string) => (event: any) => {
    setClient({ ...client, companyAddress: { ...client.companyAddress, [name]: event.target.value } })
  }

  const onClientCheckboxChangeCreator = (name: string) => (event: any) => {
    if ( name==='company' && event.target.checked ) {
      setClient({ ...client, [name]: event.target.checked, companyAddress: {
        addressId: null,
        street: null,
        town: null,
        zipCode: null,
        country: null,
      },})
    } else {
      setClient({ ...client, [name]: event.target.checked })
    }
  }

  const handleDateChangeCreator = (name: string) => (date: Date | null) => {
    setClient({ ...client, [name]: date })
  }

  const onClientRoleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setClient({ ...client, roles: event.target.value as string[] })
  }

  const onPortfolioChange = (index: number, value: string | boolean, field: string) => {
    if (index === -1) {
      setNewPortfolio({ ...newPortfolio, [field]: value })
    } else {
      let clientCopy = { ...client }
      let portfolio = clientCopy.portfolios[index]
      portfolio = { ...portfolio, [field]: value }
      clientCopy.portfolios[index] = portfolio
      setClient(clientCopy)
    }
  }

  const handleRemovePortfolio = (index: number) => {
    client.portfolios.splice(index, 1)
    let clientCopy = { ...client }
    setClient(clientCopy)
  }

  const handleSavePortfolio = () => {
    let clientCopy = { ...client }
    clientCopy.portfolios.push({ ...newPortfolio, type: 'PT_COMMON' })
    setClient(clientCopy)
    setNewPortfolio(emptyClientPortfolioType)
  }
  const [tabIndex, setTabIndex] = React.useState(0)
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabIndex(newValue)
  }

  const { getInvestments } = useInvestmentApi()
  const investments = useSelector(state => state.investments)

  const handleDownLoad = () => () => {
    const linkSource = `data:application/pdf;base64,${investments.investments[0].pdfContent}`
    const downloadLink = document.createElement('a')
    const fileName = 'id_' + client.surname + '_' + investments.investments[0].signatureDate + '.pdf'
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
  }

  useEffect(() => {
    if (
      client && client.clientId!==0 &&
      (!investments || !investments.isFetchedInvestments ||
        (investments.investments[0] && investments.investments[0].clientId !== client.clientId)) &&
        foundDialog?.payload?.type !== 'new'
    ) {
      getInvestments(client.clientId)
    }
  }, [client])

  return (
    <Dialog
      fullWidth
      classes={{ paper: classes.dialogPaper }}
      maxWidth="lg"
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <Box sx={{ marginLeft: '10px', marginTop: '10px' }}>
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="portfolios"
          className={segTabs.tabs}
        >
          <Tab
            label={t('CLIENT')}
            {...a11yProps(tabIndex)}
            className={segTabs.tab}
            iconPosition="start"
            icon={<PersonOutlineIcon fontSize="small" />}
          />

          <Tab
            label={t('REAL_PORTFOLIOS')}
            {...a11yProps(tabIndex)}
            className={segTabs.tab}
            iconPosition="start"
            icon={<AccountBalanceWalletIcon fontSize="small" />}
          />

        </Tabs>
      </Box>

      <DialogContent className={classes.clientInformationDialog}>
        <TabPanel value={tabIndex} index={0}>
          <div style={{ width: '100%', height: '100%', padding: '10px' }}>
            <div className={classes.cardsContainer}>
              <Paper className={classes.cardMuted}>
                <div className={cardHeader.header}>
                  <p className={cardHeader.title}>{t('CLIENT_PERSONAL_INFO')}</p>
                </div>
                <Grid container spacing={2}>
                  <ClientNameContainer client={client} onClientAttributeChange={onClientAttributeChange} codeList={codeList} setClient={setClient}/>
                  <ClientPersonalDataContainer
                    client={client}
                    onClientAttributeChange={onClientAttributeChange}
                    onClientPermanentAddressChange={onClientPermanentAddressChange}
                    onClientDateChange={handleDateChangeCreator}
                  />
                  {contactAdressCheckState && (
                    <ContactAdressInput client={client} onClientContactAddressChange={onClientContactAddressChange} />
                  )}
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={contactAdressCheckState}
                          onChange={contactAdressCheckStateChange}
                          name="checked"
                          color="primary"
                        />
                      }
                      label={t('CONTACT_ADDRESS_NOT_SAME')}
                    />
                  </Grid>
                </Grid>
              </Paper>

              <Paper className={classes.cardMuted}>
                <div className={cardHeader.header}>
                  <p className={cardHeader.title}>{t('CLIENT_SYSTEM_ACCESS')}</p>
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <div
                      style={{ backgroundColor: client.activeKcUser ? newThemeObject.palette.state.filled : newThemeObject.palette.state.canceled }}
                      className={classes.rowOrderState}>
                      <p className={classes.rowOrderStateText}>{getKCStatusForClient(client, t)}</p>
                    </div>
                  </Grid>
                  {!client.activeKcUser && <>
                    <Grid item xs={12} sm={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={client.shouldHaveKcUser}
                            onChange={onClientCheckboxChangeCreator('shouldHaveKcUser')}
                            id="shouldHaveKcUser"
                            color="primary"
                          />
                        }
                        label={getKCLabelForClient(client, t)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      {!client.createdKcUser && client.shouldHaveKcUser &&
                        <Alert severity="warning">{t("KC_CREATE_CHECK_EMAIL")}</Alert>
                      }
                    </Grid>
                  </>}
                  {client.activeKcUser && <>
                    <Grid item xs={12} sm={4}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!client.shouldHaveKcUser}
                            onChange={(event) => setClient({ ...client, shouldHaveKcUser: !event.target.checked })}
                            id="shouldHaveKcUser"
                            color="primary"
                          />
                        }
                        label={getKCLabelForClient(client, t)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      {!client.createdKcUser && client.shouldHaveKcUser &&
                        <Alert severity="warning">{t("KC_CREATE_CHECK_EMAIL")}</Alert>
                      }
                    </Grid>
                  </>}
                  {client.createdKcUser &&
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={client.shouldResetPassword}
                            onChange={onClientCheckboxChangeCreator('shouldResetPassword')}
                            id="shouldResetPassword"
                            color="primary"
                          />
                        }
                        label={t("RESET_PASSWORD")}
                      />
                    </Grid>
                  }
                </Grid>
              </Paper>

              <Paper className={classes.cardMuted}>
                <div className={cardHeader.header}>
                  <p className={cardHeader.title}>{t('CLIENT_COMPANY_INFO')}</p>
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={client.company}
                          onChange={onClientCheckboxChangeCreator('company')}
                          id="idCompany"
                          color="primary"
                        />
                      }
                      label={t('COMPANY')}
                    />
                  </Grid>
                  {client.company &&
                  <>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        required
                        variant="outlined"
                        id="companyName"
                        label={t('COMPANY_NAME')}
                        helperText={errors['companyName'] ? t('REQUIRE_ITEM') : ''}
                        error={errors['companyName']}
                        onChange={onClientInputChangeCreator('companyName')}
                        value={client.companyName}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        required
                        variant="outlined"
                        id="companyId"
                        label={t('COMPANY_ID')}
                        helperText={errors['companyId'] ? t('REQUIRE_ITEM') : ''}
                        error={errors['companyId']}
                        onChange={onClientInputChangeCreator('companyId')}
                        value={client.companyId}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        variant="outlined"
                        id="companyStreet"
                        label={t('STREET_NUMBER')}
                        helperText={errors['companystreet'] ? t('REQUIRE_ITEM') : ''}
                        error={errors['companystreet']}
                        onChange={onClientCompanyAddressChange('street')}
                        value={client.companyAddress?.street}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        id="companyTown"
                        variant="outlined"
                        label={t('CITY')}
                        helperText={errors['companytown'] ? t('REQUIRE_ITEM') : ''}
                        error={errors['companytown']}
                        onChange={onClientCompanyAddressChange('town')}
                        value={client.companyAddress?.town}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        required
                        variant="outlined"
                        id="companyZipCode"
                        label={t('ZIP_CODE')}
                        helperText={errors['companyzipCode'] ? t('REQUIRE_ITEM') : ''}
                        error={errors['companyzipCode']}
                        onChange={onClientCompanyAddressChange('zipCode')}
                        value={client.companyAddress?.zipCode}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        required
                        id="companyCountry"
                        label={t('COUNTRY')}
                        helperText={errors['companycountry'] ? t('REQUIRE_ITEM') : ''}
                        error={errors['companycountry']}
                        onChange={onClientCompanyAddressChange('country')}
                        value={client.companyAddress?.country}
                      />
                    </Grid>
                  </>}
                </Grid>
              </Paper>

              <Paper className={classes.cardMuted}>
                <div className={cardHeader.header}>
                  <p className={cardHeader.title}>{t('ADDITIONAL_INFORMATION')}</p>
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      multiline
                      id="note"
                      label={t('COMMENT')}
                      onChange={onClientInputChangeCreator('note')}
                      value={client.note}
                    />
                  </Grid>
                </Grid>
              </Paper>

              <Paper className={`${classes.cardMuted} ${errors['roles'] ? classes.errorBorder : ''}`}>
                <div className={cardHeader.header}>
                  <p className={cardHeader.title}>{t('CREW')}</p>
                </div>
                <FormControl fullWidth error={!valid}>
                  <Autocomplete
                    multiple
                    id="roles"
                    filterSelectedOptions
                    options={clientRoles}
                    value={client.roles ? clientRoles.filter(r => client.roles.includes(r.name)) : []}
                    getOptionLabel={(option: ClientRole) => option.name}
                    getOptionDisabled={option => client.roles && !!client.roles.find(r => r === option.name)}
                    onChange={(event: any, value: ClientRole[]) => {
                      setClient({ ...client, roles: value.map(v => v.name) })
                    }}
                    renderTags={(value: ClientRole[], getTagProps) =>
                      value.map((option: ClientRole, index: number) => (
                        <Chip classes={{ root: classes.chips }} label={option.name} {...getTagProps({ index })} />
                      ))
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder={t('CREW')}
                        helperText={errors['roles'] ? t('REQUIRE_ITEM') : ''}
                        error={errors['roles']}
                      />
                    )}
                  />
                </FormControl>
              </Paper>

              <Paper className={classes.cardMuted}>
                <div className={cardHeader.header}>
                  <p className={cardHeader.title}>{t('COUNTERPARTIES_ID')}</p>
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      id="standard-basic"
                      label={t('JT')}
                      onChange={onClientInputChangeCreator('clientCounterpartyId')}
                      value={client.clientCounterpartyId}
                    />
                  </Grid>
                </Grid>
              </Paper>

              <Paper className={classes.cardMuted}>
                <div className={cardHeader.header}>
                  <p className={cardHeader.title}>{t('INVESTMENT_QUESTIONNAIRE')}</p>
                  {investments && investments.investments[0] && investments.investments[0] && (
                    <Button
                      onClick={handleDownLoad()}
                      style={{ cursor: 'pointer' }}
                      sx={cardHeaderActionSx}
                      title={t('DOWNLOAD_QUESTIONNAIRE')}
                      startIcon={<DownloadForOfflineIcon />}
                      variant="outlined"
                    >
                      {t('DOWNLOAD_QUESTIONNAIRE')}
                    </Button>
                  )}
                </div>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      id="standard-basic"
                      label={t('INVESTMENT_HORIZONTE')}
                      onChange={onClientInputChangeCreator('investmentHorizonte')}
                      value={client.investmentHorizonte}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      id="standard-basic"
                      label={t('RISK_PROFILE')}
                      onChange={onClientInputChangeCreator('riskProfile')}
                      value={client.riskProfile}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth error={!valid}>
                      <Autocomplete
                        id="suitability"
                        options={codeListCodeItems(CLIENT_SUITABILITY, codeList)}
                        value={client.suitability || ''}
                        getOptionLabel={(a: string) => t(a)}
                        onChange={(event: any, value: string | null) => {
                          setClient({ ...client, suitability: value })
                        }}
                        renderInput={params => (
                          <TextField {...params} variant="outlined" placeholder={t('SUITABILITY') + ' *'} required helperText={errors['suitability'] ? t('REQUIRE_ITEM') : ''} error={errors['suitability']} />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        renderInput={props => (
                          <TextField variant="outlined" fullWidth={true} {...props} label={t('EXPIRATION_DATE')} />
                        )}
                        inputFormat="dd/MM/yyyy"
                        value={client.investmentQuestionnaireValidTo}
                        onChange={handleDateChangeCreator('investmentQuestionnaireValidTo')}
                        className={classes.marginTopOverride}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth error={!valid}>
                      <Autocomplete
                        id="category"
                        filterSelectedOptions
                        options={codeListCodeItems(CLIENT_CATEGORY, codeList)}
                        value={client.category || ''}
                        getOptionLabel={(a: string) => t(a)}
                        onChange={(event: any, value: string | null) => {
                          setClient({ ...client, category: value })
                        }}
                        renderInput={params => (
                          <TextField {...params} variant="outlined" placeholder={t('CLIENT_CATEGORY')} />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth error={!valid}>
                      <Autocomplete
                        id="skillAndExperience"
                        filterSelectedOptions
                        options={codeListCodeItems(CLIENT_EXPERIENCE, codeList)}
                        value={client.skillAndExperience || ''}
                        getOptionLabel={(a: string) => t(a)}
                        onChange={(event: any, value: string | null) => {
                          setClient({ ...client, skillAndExperience: value })
                        }}
                        renderInput={params => (
                          <TextField {...params} variant="outlined" placeholder={t('KONWLEDGE_AND_EXPERIENCE')} />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth error={!valid}>
                      <Autocomplete
                        id="preference"
                        filterSelectedOptions
                        options={codeListCodeItems(CLIENT_PREFERENCE, codeList)}
                        value={client.preference || ''}
                        getOptionLabel={(a: string) => t(a)}
                        onChange={(event: any, value: string | null) => {
                          setClient({ ...client, preference: value })
                        }}
                        renderInput={params => (
                          <TextField {...params} variant="outlined" placeholder={t('INVESTMENT_PREFERENCES')} />
                        )}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth error={!valid}>
                      <Autocomplete
                        id="lossAbility"
                        filterSelectedOptions
                        options={codeListCodeItems(CLIENT_LOSS_ABILITY, codeList)}
                        value={client.lossAbility || ''}
                        getOptionLabel={(a: string) => t(a)}
                        onChange={(event: any, value: string | null) => {
                          setClient({ ...client, lossAbility: value })
                        }}
                        renderInput={params => (
                          <TextField {...params} variant="outlined" placeholder={t('RISK_APPROVE')} />
                        )}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Paper>

              <Paper className={classes.cardMuted}>
                <div className={cardHeader.header}>
                  <p className={cardHeader.title}>{t('FEES_ORDER')}</p>
                </div>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      required
                      variant="outlined"
                      id="fee_bonds"
                      label={t('FEE_BONDS')}
                      onChange={onClientInputChangeCreator('feeBond')}
                      value={client.feeBond}
                      helperText={errors['feeBond'] ? t('REQUIRE_ITEM') : ''}
                      error={errors['feeBond']}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      required
                      variant="outlined"
                      id="fee_etf"
                      label={t('FEE_ETF')}
                      onChange={onClientInputChangeCreator('feeETF')}
                      value={client.feeETF}
                      helperText={errors['feeETF'] ? t('REQUIRE_ITEM') : ''}
                      error={errors['feeETF']}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      id="fee_equities"
                      label={t('FEE_EQUITIES')}
                      onChange={onClientInputChangeCreator('feeEquity')}
                      value={client.feeEquity}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      id="fee_options"
                      label={t('FEE_OPTIONS')}
                      onChange={onClientInputChangeCreator('feeOption')}
                      value={client.feeOption}
                    />
                  </Grid>
                </Grid>
              </Paper>

              <Paper className={classes.cardMuted}>
                <div className={cardHeader.header}>
                  <p className={cardHeader.title}>{t('CONTRACTS')}</p>
                  <ColoredIconButton icon={<AddIcon />} size='small' onClick={()=>{
                    if ( client ) {
                      if ( client.contracts ) {
                        let tmp : Contract[] = [...client.contracts]
                        tmp.push({contractId:tmp.length+1, uid: null, contractType: null, contractDate: null})
                        setClient({...client, contracts: tmp});
                      } else {
                        let tmp : Contract[] = [{contractId:1, uid: null, contractType: null, contractDate: null}];
                        setClient({...client, contracts: tmp});
                      }
                    }
                  }}/>
                </div>
                <Grid container spacing={3}>
                  { client && client.contracts && client.contracts.map((contract: Contract, index)=> (
                    <>
                      <Grid item xs={12} sm={6} md={3}>
                        <TextField variant="outlined" fullWidth id={"uid"+index} label={t('UID')} value={contract.uid} onChange={hadleChangeUid(contract)}/>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            renderInput={props => (
                              <TextField variant="outlined" fullWidth={true} {...props} label={t('SIGNATURE_DATE')} />
                            )}
                            inputFormat="dd/MM/yyyy"
                            value={contract.contractDate}
                            // onChange={handleDateChangeCreator('contractDate')}
                            onChange={(date: any, keyboardInputValue?: string | undefined) => {
                              if ( client && client.contracts ) {
                                let tmpList : Contract[] = client.contracts ? [...client.contracts] : [];
                                for ( let i=0; i<client.contracts?.length; i++) {
                                  if ( client.contracts[i].contractId === contract.contractId) {
                                    client.contracts[i].contractDate = date
                                  }
                                }
                                setClient({...client, contracts: tmpList});
                              }
                            }}

                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <FormControl fullWidth>
                          <Autocomplete
                            id={"contractType"+index}
                            options={codeListCodeItems(CONTRACT_TYPE, codeList)}
                            value={contract.contractType || ''}
                            getOptionLabel={(a: string) => t(a)}
                            onChange={(event: any, value: string | null) => {
                              if ( client && client.contracts ) {
                                let tmpList : Contract[] = client.contracts ? [...client.contracts] : [];
                                for ( let i=0; i<client.contracts?.length; i++) {
                                  if ( client.contracts[i].contractId === contract.contractId) {
                                    client.contracts[i].contractType = value
                                  }
                                }
                                setClient({...client, contracts: tmpList});
                              }
                            }}
                            renderInput={params => (
                              <TextField {...params} variant="outlined" placeholder={t('CONSTRACT_TYPE')} />
                            )}
                          />
                        </FormControl>
                      </Grid>


                      <Grid item xs={12} sm={6} md={2}>
                        <ColoredIconButton icon={<RemoveIcon />} size='small' className={classes.buttonRemove} onClick={()=>{
                          if ( client && client.clientPersons ) {
                            let tmp : Contract[] = [...client.contracts]
                            tmp.splice(tmp.indexOf(contract), 1)
                            setClient({...client, contracts: tmp});
                          }
                        }} />
                      </Grid>
                    </>
                  ))}
                </Grid>
              </Paper>

              <Paper className={classes.cardMuted}>
                <div className={cardHeader.header}>
                  <p className={cardHeader.title}>{t('CONTACT_PERSONS')}</p>
                  <ColoredIconButton icon={<AddIcon />} size='small' onClick={()=>{
                    if ( client ) {
                      if ( client.clientPersons ) {
                        let tmp : ClientPerson[] = [...client.clientPersons]
                        tmp.push({clientPersonId:tmp.length+1, person: null, type: null})
                        setClient({...client, clientPersons: tmp});
                      } else {
                        let tmp : ClientPerson[] = [{clientPersonId:1, person: null, type: null}];
                        setClient({...client, clientPersons: tmp});
                      }
                    }
                  }}/>
                </div>
                <Grid container spacing={3}>
                  {client && client.clientPersons && client.clientPersons.map((person: ClientPerson, index)=> (
                    <>
                      <Grid item xs={12} sm={5}>

                        <FormControl fullWidth error={!valid}>
                          <Autocomplete
                            id={'contactPerson'+index}
                            options={personsItems(persons)}
                            value={person.person ? person.person.firstName +' ' +person.person.surname : ''}
                            getOptionLabel={(a: string) => a}
                            onChange={(event: any, value: string | null) => {
                              if ( client && client.clientPersons ) {
                                let tmpList : ClientPerson[] = client.clientPersons ? [...client.clientPersons] : [];
                                for ( let i=0; i<client.clientPersons?.length; i++) {
                                  if ( client.clientPersons[i].clientPersonId === person.clientPersonId) {
                                    client.clientPersons[i].person = persons.filter(item=>item.firstName+' '+item.surname===value)[0]
                                  }
                                }
                                setClient({...client, clientPersons: tmpList});
                              }
                            }}
                            renderInput={params => (
                              <TextField {...params} variant="outlined" placeholder={t('CONTACT_PERSON') + ' *'} />
                            )}
                          />
                        </FormControl>

                      </Grid>
                      <Grid item xs={12} sm={5}>

                        <FormControl fullWidth error={!valid}>
                          <Autocomplete
                            id={'contactType'+index}
                            options={codeListCodeItems(PERSON_CONTACT_TYPE, codeList)}
                            value={person.type || ''}
                            getOptionLabel={(a: string) => t(a)}
                            onChange={(event: any, value: string | null) => {
                              if ( client && client.clientPersons ) {
                                let tmpList : ClientPerson[] = client.clientPersons ? [...client.clientPersons] : [];
                                for ( let i=0; i<client.clientPersons?.length; i++) {
                                  if ( client.clientPersons[i].clientPersonId === person.clientPersonId) {
                                    client.clientPersons[i].type = value
                                  }
                                }
                                setClient({...client, clientPersons: tmpList});
                              }
                            }}
                            renderInput={params => (
                              <TextField {...params} variant="outlined" placeholder={t('CONTACT_TYPE') + ' *'} />
                            )}
                          />
                        </FormControl>

                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <ColoredIconButton icon={<RemoveIcon />} size='small' className={classes.buttonRemove} onClick={()=>{
                          if ( client && client.clientPersons ) {
                            let tmp : ClientPerson[] = [...client.clientPersons]
                            tmp.splice(tmp.indexOf(person), 1)
                            setClient({...client, clientPersons: tmp});
                          }
                        }} />
                      </Grid>
                    </>
                  ))}

                </Grid>
              </Paper>
            </div>
          </div>
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <PortfolioDetail
              portfolio={newPortfolio}
              errors={errors}
              onPortfolioChange={onPortfolioChange}
              handleSave={handleSavePortfolio}
              index={-1}
            />
            <div className={`${classes.portfolioList} ${classes.portfolioListReal}`}>
              {client.portfolios.map((portfolio: ClientPortfolioType, index: number) => {
                return portfolio.type !== 'PT_VIRTUAL' && portfolio.type !== 'PT_ALL' ? (
                  <PortfolioDetail
                    portfolio={portfolio}
                    errors={errors}
                    onPortfolioChange={onPortfolioChange}
                    index={index}
                    handleRemove={(indexS: number) => {
                      handleRemovePortfolio(indexS)
                    }}
                    showError={true}
                  />
                ) : (
                  <></>
                )
              })}
            </div>
          </div>
        </TabPanel>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <ClientInformationDialogFooter
          displaySection={tabIndex === 0}
          client={client}
          handleClose={handleClose}
          handleSave={onSubmitClick}
        />
      </DialogActions>
      <ActionFailedAlert handleClose={() => { }} />
      <ActionAlert />
    </Dialog >
  )
}
